import { SET_TOP_BAR_TITLE } from './types';

export const setTitle = title => ({
  type: SET_TOP_BAR_TITLE,
  payload: title,
});



// WEBPACK FOOTER //
// ./src/actions/topbar.actions.js